import { render } from "./UserPreview.vue?vue&type=template&id=5c3c6fc6"
import script from "./UserPreview.vue?vue&type=script&lang=js"
export * from "./UserPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__